"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.addDevelopmentDelay = exports.NoResultEl = exports.useAsyncAction = exports.LoadingEl = exports.useAsync = void 0;
var react_1 = __importStar(require("react"));
var Loading_1 = require("./Loading");
var material_1 = require("@mui/material");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Auth_1 = require("./Auth");
var green_1 = __importDefault(require("@mui/material/colors/green"));
function useAsync(fx, options) {
    var _this = this;
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(null), value = _b[0], setValue = _b[1];
    var _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1];
    var _d = (0, react_1.useState)(false), isInit = _d[0], setIsInit = _d[1];
    var _e = (0, react_1.useState)(0), _ = _e[0], setLoadId = _e[1];
    var cb = (options === null || options === void 0 ? void 0 : options.dependsOn) ? (0, react_1.useCallback)(fx, options === null || options === void 0 ? void 0 : options.dependsOn) : fx;
    var load = (0, react_1.useCallback)(function (input) { return __awaiter(_this, void 0, void 0, function () {
        var thisLoadId_1, result, isActiveRequest_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setError(null);
                    setLoading(true);
                    setIsInit(true);
                    thisLoadId_1 = 0;
                    setLoadId(function (old) {
                        thisLoadId_1 = (old + 1) % 1000;
                        return thisLoadId_1;
                    });
                    return [4 /*yield*/, addDevelopmentDelay(cb(input))];
                case 1:
                    result = _a.sent();
                    isActiveRequest_1 = true;
                    setLoadId(function (old) {
                        isActiveRequest_1 = old === thisLoadId_1;
                        return old;
                    });
                    if (!isActiveRequest_1)
                        return [2 /*return*/];
                    if (result && typeof result === 'object') {
                        if ('error' in result)
                            throw new Error(result.error);
                    }
                    setValue(result);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    setError(e_1.toString());
                    return [3 /*break*/, 3];
                case 3:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [cb]);
    var reload = (0, react_1.useCallback)(load, [cb]);
    var status = (0, Auth_1.useAuthenticated)();
    var hasDeps = !!(options === null || options === void 0 ? void 0 : options.dependsOn);
    (0, react_1.useEffect)(function () {
        if (isInit && !hasDeps)
            return;
        if (!(options === null || options === void 0 ? void 0 : options.withoutAuth)) {
            if (!status.authenticated) {
                setError('Not authenticated');
                return;
            }
        }
        load();
    }, [isInit, status, load, options, hasDeps]);
    var LoadingElement = LoadingEl(loading, error, reload);
    var NoResultElement = NoResultEl(LoadingElement, value);
    return {
        LoadingElement: LoadingElement,
        NoResultElement: NoResultElement,
        LoadingOrErrorElement: LoadingElement,
        loadingOrError: loading || error !== null,
        loading: loading,
        error: error,
        result: value,
        asList: value || defaultArray,
        reload: reload,
    };
}
exports.useAsync = useAsync;
var defaultArray = [];
function LoadingEl(loading, error, reload) {
    if (loading) {
        return react_1.default.createElement(Loading_1.Loading, null);
    }
    if (error) {
        return (react_1.default.createElement(material_1.Grid, { container: true, alignItems: "center", spacing: 1 },
            react_1.default.createElement(material_1.Grid, { item: true },
                react_1.default.createElement(Typography_1.default, { color: "error" }, error)),
            reload && (react_1.default.createElement(material_1.Grid, { item: true },
                react_1.default.createElement(Button_1.default, { onClick: function () { return reload(); } }, "Retry")))));
    }
    return null;
}
exports.LoadingEl = LoadingEl;
function useAsyncAction(callback, dependsOn) {
    var _this = this;
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(null), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(null), result = _c[0], setResult = _c[1];
    var _d = (0, react_1.useState)(0), _ = _d[0], setLoadId = _d[1];
    var _e = (0, react_1.useState)(false), showSuccess = _e[0], setShowSuccess = _e[1];
    // automatically return showSuccess to false after timeout
    (0, react_1.useEffect)(function () {
        if (!showSuccess)
            return;
        var id = setTimeout(function () {
            setShowSuccess(false);
        }, 5000);
        return function () { return clearTimeout(id); };
    }, [showSuccess]);
    var theCallback = (0, react_1.useCallback)(function (arg) { return __awaiter(_this, void 0, void 0, function () {
        var thisLoadId_2, actionResult, isActiveRequest_2, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setError(null);
                    setLoading(true);
                    thisLoadId_2 = 0;
                    setLoadId(function (old) {
                        thisLoadId_2 = (old + 1) % 1000;
                        return thisLoadId_2;
                    });
                    return [4 /*yield*/, addDevelopmentDelay(callback(arg))];
                case 1:
                    actionResult = _a.sent();
                    if (actionResult && typeof actionResult === 'object' && 'error' in actionResult) {
                        throw new Error(actionResult.error);
                    }
                    isActiveRequest_2 = true;
                    setLoadId(function (old) {
                        isActiveRequest_2 = old === thisLoadId_2;
                        return old;
                    });
                    if (!isActiveRequest_2)
                        return [2 /*return*/];
                    setLoading(false);
                    setResult(actionResult);
                    setShowSuccess(true);
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    setError(e_2.toString());
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, dependsOn);
    var LoadingElement = LoadingEl(loading, error);
    var NoResultElement = NoResultEl(LoadingElement, result);
    var SuccessElement = showSuccess ? (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' } },
        react_1.default.createElement(Typography_1.default, { style: { color: green_1.default['800'] }, variant: "body1" }, "Success"))) : null;
    return {
        LoadingElement: LoadingElement || SuccessElement,
        loading: loading,
        error: error,
        callback: theCallback,
        result: result,
        NoResultElement: NoResultElement,
    };
}
exports.useAsyncAction = useAsyncAction;
function NoResultEl(LoadingElement, result) {
    if (LoadingElement === null) {
        var isBlankArray = result instanceof Array && result.length === 0;
        if (result === null || isBlankArray) {
            return (react_1.default.createElement(Typography_1.default, { style: { padding: 16 }, variant: "body2", color: "textSecondary" }, "Nothing here"));
        }
    }
    return null;
}
exports.NoResultEl = NoResultEl;
function addDevelopmentDelay(p) {
    return __awaiter(this, void 0, void 0, function () {
        var isLocalHost, start, result, spent, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLocalHost = window.location && window.location.hostname === 'localhost';
                    if (!isLocalHost) {
                        return [2 /*return*/, p];
                    }
                    start = new Date().getTime();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 6]);
                    return [4 /*yield*/, p];
                case 2:
                    result = _a.sent();
                    spent = new Date().getTime() - start;
                    return [4 /*yield*/, sleep(200 * Math.random() + 100 - spent)];
                case 3:
                    _a.sent();
                    return [2 /*return*/, result];
                case 4:
                    e_3 = _a.sent();
                    return [4 /*yield*/, sleep(200 * Math.random() + 100)];
                case 5:
                    _a.sent();
                    throw e_3;
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.addDevelopmentDelay = addDevelopmentDelay;
function sleep(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (ms <= 0)
                return [2 /*return*/];
            return [2 /*return*/, new Promise(function (resolve) {
                    setTimeout(resolve, ms);
                })];
        });
    });
}
exports.sleep = sleep;
